export default function PizzaIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#F9D11F"
        d="m18.205 13.955-.28-.679-3.231-7.803a.293.293 0 0 0-.159-.159L6.046 1.8a.291.291 0 0 0-.39.177L5.13 3.53.062 18.507l-.002.004a1.12 1.12 0 0 0 .27 1.158 1.124 1.124 0 0 0 1.159.27l9.606-3.249.532-.55 2.445-.457 2.401-.812 1.556-.526a.292.292 0 0 0 .176-.39Z"
      />
      <path
        fill="#FFA402"
        d="m18.029 14.345-1.556.526-2.4.812-2.446.457-.532.55-9.606 3.25A1.127 1.127 0 0 1 .06 18.51l.002-.004c.413.357.987.472 1.51.296l16.352-5.527.281.679a.294.294 0 0 1-.176.39Z"
      />
      <path
        fill="#FDEDA5"
        d="m18.029 14.345-1.556.526c-.075-.32-.168-.658-.282-1.009-.591-1.81-1.75-3.99-3.951-6.192-2.629-2.627-5.123-3.665-7.099-4.128l-.01-.01.526-1.556a.293.293 0 0 1 .39-.177l8.488 3.515c.072.03.129.087.159.159l3.23 7.803.281.679a.293.293 0 0 1-.176.39Z"
      />
      <path
        fill="#FBDF63"
        d="m18.029 14.345-1.556.526c-.075-.32-.168-.658-.282-1.009l1.733-.586.281.679a.293.293 0 0 1-.176.39Z"
      />
      <path
        fill="#F79E60"
        d="M19.975 13.65c-.436-2.076-1.66-5.254-5.016-8.61C11.6 1.682 8.423.46 6.347.024a1.17 1.17 0 0 0-1.065 1.972c.159.16.36.269.585.316 1.765.37 4.488 1.43 7.439 4.38 2.95 2.95 4.01 5.672 4.38 7.436a1.166 1.166 0 0 0 2.123.4 1.16 1.16 0 0 0 .166-.88Z"
      />
      <path
        fill="#D77D41"
        d="M19.975 13.65c-.436-2.076-1.66-5.254-5.016-8.61C11.6 1.682 8.423.46 6.347.024a1.17 1.17 0 0 0-1.37.843c.172-.046.356-.053.542-.014 2.075.435 5.254 1.658 8.611 5.014 3.357 3.357 4.58 6.535 5.016 8.61.038.182.033.366-.014.54a1.16 1.16 0 0 0 .677-.49 1.16 1.16 0 0 0 .166-.879Z"
      />
      <path
        fill="#ED2061"
        d="M9.275 7.76c0-.493-.192-.956-.54-1.304a1.847 1.847 0 0 0-3.15 1.304 1.833 1.833 0 0 0 .54 1.304 1.847 1.847 0 0 0 3.15-1.304Zm-1.533 4.495a1.848 1.848 0 0 0-3.15 1.305c0 .492.191.956.54 1.304a1.848 1.848 0 0 0 3.15-1.304c0-.493-.192-.956-.54-1.305Zm6.33 3.428-2.979 1-.128-.128a1.839 1.839 0 0 1 0-2.609c.36-.359.832-.539 1.305-.539.472 0 .945.18 1.304.54a1.84 1.84 0 0 1 .523 1.557l-.024.18Z"
      />
      <path
        fill="#C71E54"
        d="m14.073 15.683-2.98 1-.128-.128a1.84 1.84 0 0 1-.463-.77L14 14.602c.106.282.141.59.098.9l-.024.18Z"
      />
      <path
        fill="#68C044"
        d="M4.414 15.84a.293.293 0 0 0-.248-.249 2.291 2.291 0 0 0-.502-.007c-.385.037-.702.169-.915.382-.214.214-.346.53-.382.915-.025.27.003.48.007.503a.292.292 0 0 0 .248.247c.023.004.233.033.502.007.385-.036.701-.168.915-.381.214-.214.346-.53.382-.916a2.292 2.292 0 0 0-.007-.502Zm6.748-3.174c.008-.022.084-.22.12-.488.054-.383-.003-.721-.162-.978-.16-.257-.438-.458-.804-.58a2.29 2.29 0 0 0-.491-.108.293.293 0 0 0-.298.185 2.29 2.29 0 0 0-.121.487c-.053.383.003.721.163.978.045.072.099.14.161.203.161.16.38.29.643.378.256.085.467.105.49.107.13.011.251-.064.298-.184Z"
      />
      <path
        fill="#FDEDA5"
        d="m5.824 10.597-.447-.696a.293.293 0 1 0-.493.316l.447.697a.293.293 0 0 0 .493-.316Zm6.252-.775-.63-.539a.293.293 0 1 0-.38.445l.628.539a.293.293 0 0 0 .382-.445Zm-2.6 5.614.079-.755a.293.293 0 0 0-.583-.061l-.079.755a.292.292 0 1 0 .583.061Z"
      />
    </svg>
  );
}
